<template>
  <div id="to-result">
    <div v-if="!result">
      <not-found></not-found>
    </div>
    <div v-if="result.status" class="u-radius-g u-margin-bottom-xsmall">
      <h6
        class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
        @click="toggleSection('cycleOutput')"
      >
        <div class="u-display-inline-flex u-align-items-center">
          <span
            class="u-margin-right-xsmall u-circle u-circle__variant--small"
            :class="`u-circle__variant--success`"
          >
            <i :class="`icofont-check`"></i>
          </span>
          <div>
            <div>
              {{ $t("cyclesForm.cycleOutput") }}
            </div>
          </div>
        </div>
        <i
          :class="`icofont-rounded-${
            activeSections.includes('cycleOutput') ? 'up' : 'down'
          }`"
        ></i>
      </h6>
      <div
        class="u-padding-xxsmall"
        v-if="activeSections.includes('cycleOutput')"
      >
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.coolingCapacity')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.coolPropCalculateResponse.cycle_cooling.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.work')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.coolPropCalculateResponse.cycle_work.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.massFlow')"
              suffix="kg/h"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.coolPropCalculateResponse.cycle_mass_flow.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.rejectedHeat')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.coolPropCalculateResponse.cycle_rej_heat.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.sensibleCapacity')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.coolPropCalculateResponse.evap_sensible_capacity.toFixed(
                  2
                )
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.sensibleHeatRatio')"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.capacityRatio.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.drainWaterFlow')"
              suffix="kg/h"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.condensatedFlow.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.EER')"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.compressorResponse.comp_eer.toFixed(2)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="result.status" class="u-radius-g u-margin-bottom-xsmall">
      <h6
        class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
        @click="toggleSection('compressorOutput')"
      >
        <div class="u-display-inline-flex u-align-items-center">
          <span
            class="u-margin-right-xsmall u-circle u-circle__variant--small"
            :class="`u-circle__variant--success`"
          >
            <i :class="`icofont-check`"></i>
          </span>
          <div>
            <div>
              {{ $t("cyclesForm.compressorOutput") }}
            </div>
          </div>
        </div>
        <i
          :class="`icofont-rounded-${
            activeSections.includes('compressorOutput') ? 'up' : 'down'
          }`"
        ></i>
      </h6>
      <div
        class="u-padding-xxsmall"
        v-if="activeSections.includes('compressorOutput')"
      >
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.compressorCapacity')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.compressorResponse.comp_ref_capacity.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.heatingCapacity')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.compressorResponse.comp_cond_capacity.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.compressorMassFlow')"
              suffix="kg/h"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.compressorResponse.comp_ref_mass_flow.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.compressorPower')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.compressorResponse.comp_electrical_power.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cyclesForm.compressorCurrent')"
              suffix="A"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.compressorResponse.comp_current.toFixed(2)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="result.status" class="u-radius-g u-margin-bottom-xsmall">
      <h6
        class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
        @click="toggleSection('condenserOutput')"
      >
        <div class="u-display-inline-flex u-align-items-center">
          <span
            class="u-margin-right-xsmall u-circle u-circle__variant--small"
            :class="`u-circle__variant--success`"
          >
            <i :class="`icofont-check`"></i>
          </span>
          <div>
            <div>
              {{ $t("cyclesForm.condenserOutput") }}
            </div>
          </div>
        </div>
        <i
          :class="`icofont-rounded-${
            activeSections.includes('condenserOutput') ? 'up' : 'down'
          }`"
        ></i>
      </h6>
      <div
        class="u-padding-xxsmall"
        v-if="activeSections.includes('condenserOutput')"
      >
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              readonly
              :label="$t('cyclesForm.condenserCapacity')"
              suffix="kW"
              size="xs"
              :value="result.condenserResponse.capacity.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserTemperature')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.coolPropCalculateResponse.coolprop_Cond_Temp.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserFldMassFlow')"
              suffix="kg/h"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.fldMassFlow.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserAirPressureDrop')"
              suffix="Pa"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.airPressureDrop.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserAirTemperatureOutlet')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.airTemperatureOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserAirHumidityOutlet')"
              suffix="%"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.airHumidityOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserAirTemperatureWetbulbOutlet')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.condenserResponse.airTemperatureWetbulbOutlet.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserAirVelocityOutlet')"
              suffix="m/s"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.airVelocityOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserFldPressureDrop')"
              suffix="kPa"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.fldPressureDrop.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.condenserFldPressureDrop')"
              suffix="K"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.condenserResponse.fldPressureDropKelvin.toFixed(2)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="result.status" class="u-radius-g u-margin-bottom-xsmall">
      <h6
        class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
        @click="toggleSection('evaporatorOutput')"
      >
        <div class="u-display-inline-flex u-align-items-center">
          <span
            class="u-margin-right-xsmall u-circle u-circle__variant--small"
            :class="`u-circle__variant--success`"
          >
            <i :class="`icofont-check`"></i>
          </span>
          <div>
            <div>
              {{ $t("cyclesForm.evaporatorOutput") }}
            </div>
          </div>
        </div>
        <i
          :class="`icofont-rounded-${
            activeSections.includes('evaporatorOutput') ? 'up' : 'down'
          }`"
        ></i>
      </h6>
      <div
        class="u-padding-xxsmall"
        v-if="activeSections.includes('evaporatorOutput')"
      >
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorCapacity')"
              suffix="kW"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.capacity.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorTemperature')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.coolPropCalculateResponse.coolprop_Evap_Temp.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorFldMassFlow')"
              suffix="kg/h"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.fldMassFlow.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorAirPressureDrop')"
              suffix="Pa"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.airPressureDrop.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorAirTemperatureOutlet')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.airTemperatureOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorAirHumidityOutlet')"
              suffix="%"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.airHumidityOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorAirTemperatureWetbulbOutlet')"
              icon="celsius"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="
                result.evaporatorResponse.airTemperatureWetbulbOutlet.toFixed(2)
              "
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorAirVelocityOutlet')"
              suffix="m/s"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.airVelocityOutlet.toFixed(2)"
            />
          </div>
          <div class="es-xs-12 es-sm-4">
            <BaseInput
              block
              readonly
              :label="$t('cycleDetail.evaporatorFldPressureDrop')"
              suffix="kPa"
              size="xs"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :value="result.evaporatorResponse.fldPressureDrop.toFixed(2)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="result.status" class="u-radius-g u-margin-bottom-xsmall">
      <h6
        class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
        @click="toggleSection('coolingCycleOutput')"
      >
        <div class="u-display-inline-flex u-align-items-center">
          <span
            class="u-margin-right-xsmall u-circle u-circle__variant--small"
            :class="`u-circle__variant--success`"
          >
            <i :class="`icofont-check`"></i>
          </span>
          <div>
            <div>
              {{ $t("cyclesForm.coolingCycleOutput") }}
            </div>
          </div>
        </div>
        <i
          :class="`icofont-rounded-${
            activeSections.includes('coolingCycleOutput') ? 'up' : 'down'
          }`"
        ></i>
      </h6>
      <div class="u-overflow-x-auto">
        <CycleSchema
          v-if="activeSections.includes('coolingCycleOutput') && result.status"
          :cycle="convertResultToCycle"
        ></CycleSchema>
      </div>
    </div>
    <CoolingCapacity
      ref="coolingCapacity"
      @request="CalculateCycle"
      :model="result?.form?.model || ''"
      :refrigerants="refrigerantId"
    />
    <div
      v-if="result.status"
      class="u-radius-g u-margin-bottom u-padding-xxsmall"
    >
      <h6 class="u-margin-bottom-none">
        <strong>
          <i class="icofont-save u-font-size-xsmall u-margin-right-xsmall"></i>
          {{ $t("cyclesForm.saveCycleTitle") }}
        </strong>
      </h6>
      <p class="u-margin-bottom u-color-muted">
        <small>
          {{ $t("cyclesForm.saveCycleDescription") }}
        </small>
      </p>
      <BaseInput
        v-model="seriNo"
        :label="$t('cyclesForm.seriNo')"
        :mandotary="result ? true : false"
        block
        :placeholder="$t('cyclesForm.seriNoPlaceholder')"
      ></BaseInput>
      <div class="u-margin-top-small">
        <v-date-picker
          :value="date"
          :locale="$i18n.locale"
          @input="(e) => changeDate(e, 'date')"
          color="purple"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <div v-on="inputEvents">
              <BaseInput
                :value="inputValue"
                :label="$t('cyclesForm.date')"
                block
                :placeholder="$t('cyclesForm.datePlaceholder')"
              ></BaseInput>
            </div>
          </template>
        </v-date-picker>
      </div>
      <Button
        :disabled="!result.status || !seriNo"
        block
        @click="saveCycle"
        variant="primary"
      >
        <i class="icofont-save"></i> {{ $t("common.save") }}
      </Button>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import NotFound from "@/components/Base/NotFound.vue";
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import CoolingCapacity from "./CoolingCapacity.vue";
import CycleSchema from "../../CycleDetail/CycleSchema.vue";

export default {
  components: {
    BaseInput,
    NotFound,
    Button,
    CoolingCapacity,
    CycleSchema,
  },
  computed: {
    convertResultToCycle() {
      return {
        // Sıcaklık değerleri (°C)
        coolPropSuperheat:
          this.result.coolPropCalculateResponse.coolprop_Superheat, // Aşırı kızgınlık sıcaklığı
        evaporatorTemperature:
          this.result.coolPropCalculateResponse.coolprop_Evap_Temp, // Evaporatör sıcaklığı
        coolPropDischargeTemp:
          this.result.coolPropCalculateResponse.coolprop_DischargeTemp, // Deşarj sıcaklığı
        condenserTemperature:
          this.result.coolPropCalculateResponse.coolprop_Cond_Temp, // Kondenser sıcaklığı
        coolPropSubcool: this.result.coolPropCalculateResponse.coolprop_Subcool, // Aşırı soğutma sıcaklığı

        // Entalpi değerleri (kJ/kg)
        coolPropH1EvapOutCompIn:
          this.result.coolPropCalculateResponse.h1_evap_out_comp_in, // Evaporatör çıkışı/Kompresör girişi
        coolPropH2CompOutCondIn:
          this.result.coolPropCalculateResponse.h2_comp_out_cond_in, // Kompresör çıkışı/Kondenser girişi
        coolPropH3CondOutExpIn:
          this.result.coolPropCalculateResponse.h3_conp_out_exp_in, // Kondenser çıkışı/Genleşme vanası girişi
        coolPropH4ExpOutEvapIn:
          this.result.coolPropCalculateResponse.h4_exp_out_evap_in, // Genleşme vanası çıkışı/Evaporatör girişi

        // Basınç değerleri (BAR)
        hp: this.result.coolPropCalculateResponse.coolprop_HPressure, // Yüksek basınç
        lp: this.result.coolPropCalculateResponse.coolprop_LPressure, // Düşük basınç

        // Diğer değerler
        coolPropX4: this.result.coolPropCalculateResponse.x4, // x4 değeri
      };
    },
  },
  props: {
    refrigerantId: {
      type: Number,
      default: 8,
    },
    result: {
      type: Object,
      required: true,
      default: () => ({
        te: null,
        tc: null,
        condFanAirFlow: null,
        evap_mutlak_debi: null,
        cond_mutlak_debi: null,
        condenserResponse: {
          capacity: null,
          airPressureDrop: null,
          airTemperatureWetbulbOutlet: null,
          airTemperatureOutlet: null,
          airVelocityOutlet: null,
          airHumidityOutlet: null,
          passCount: null,
          lDmax: null,
          hr: null,
          lh: null,
          th: null,
          fldPressureDrop: null,
          fldMassFlow: null,
          condensatedFlow: null,
          fldPressureDropKelvin: null,
          exceptionMessage: null,
          isSuccess: null,
        },
        evaporatorResponse: {
          capacity: null,
          airPressureDrop: null,
          airTemperatureWetbulbOutlet: null,
          airTemperatureOutlet: null,
          airVelocityOutlet: null,
          airHumidityOutlet: null,
          passCount: null,
          lDmax: null,
          hr: null,
          lh: null,
          th: null,
          fldPressureDrop: null,
          fldMassFlow: null,
          condensatedFlow: null,
          fldPressureDropKelvin: null,
          exceptionMessage: null,
          isSuccess: null,
        },
        coolPropCalculateResponse: {
          coolprop_Cond_Temp: null,
          coolprop_Evap_Temp: null,
          coolprop_LPressure: null,
          coolprop_HPressure: null,
          coolprop_DischargeTemp: null,
          h1_evap_out_comp_in: null,
          h2_comp_out_cond_in: null,
          h3_conp_out_exp_in: null,
          h4_exp_out_evap_in: null,
          x4: null,
          cycle_work: null,
          cycle_mass_flow: null,
          cycle_cooling: null,
          cycle_rej_heat: null,
          coolprop_Subcool: null,
          coolprop_Superheat: null,
          evap_sensible_capacity: null,
        },
        compressorResponse: {
          comp_ref_capacity: null,
          comp_cond_capacity: null,
          comp_ref_mass_flow: null,
          comp_electrical_power: null,
          comp_eer: null,
          comp_current: null,
        },
        form: {
          refrigerantId: null,
          superheat: null,
          subcooling: null,
          condensingTemp: null,
          condenserFanFlow: null,
          condenserAirInletTemp: null,
          condenserAirInletHumidity: null,
          evaporatorAirInletTemp: null,
          evaporatorAirInletHumidity: null,
          evaporatorFanFlow: null,
          evapBatteryId: null,
          condBatteryId: null,
          evapQuantity: null,
          condQuantity: null,
          compressorBrandId: null,
          compressorRefrigerantId: null,
          compRefrigetantModelId: null,
          compressorQuantity: null,
          constantAirFlowRate: null,
          variableAirFlowRate: null,
        },
      }),
    },
  },
  data() {
    return {
      activeSections: [
        "condenserOutput",
        "evaporatorOutput",
        "compressorOutput",
        "cycleOutput",
        "coolingCycleOutput",
      ],
      seriNo: null,
      date: new Date(),
    };
  },
  methods: {
    toggleSection(section) {
      this.activeSections.includes(section)
        ? this.activeSections.splice(this.activeSections.indexOf(section), 1)
        : this.activeSections.push(section);
    },
    changeDate(e, type) {
      this[type] = new Date(e).toISOString();
    },
    setForm(cycleItem = {}) {
      return {
        model: this.result.form.model,
        projectId: this.result.form.projectId,
        serialNumber: this.seriNo,
        calculationDate: this.date,
        refrigerantId: this.result.form.refrigerantId,
        superheat: this.result.form.superheat,
        subcooling: this.result.form.subcooling,
        condensingTemp: this.result.form.condensingTemp,
        condenserFanFlow: this.result.form.condenserFanFlow,
        condenserAirInletTemp: this.result.form.condenserAirInletTemp,
        condenserAirInletHumidity: this.result.form.condenserAirInletHumidity,
        evaporatorAirInletTemp: this.result.form.evaporatorAirInletTemp,
        evaporatorAirInletHumidity: this.result.form.evaporatorAirInletHumidity,
        evaporatorFanFlow: this.result.form.evaporatorFanFlow,
        evapBatteryId: this.result.form.evapBatteryId,
        condBatteryId: this.result.form.condBatteryId,
        evapQuantity: this.result.form.evapQuantity,
        condQuantity: this.result.form.condQuantity,
        compressorBrandId: this.result.form.compressorBrandId,
        compressorRefrigerantId: this.result.form.compressorRefrigerantId,
        compRefrigetantModelId: this.result.form.compRefrigetantModelId,
        compressorQuantity: this.result.form.compressorQuantity,
        constantAirFlowRate: this.result.form.constantAirFlowRate,
        variableAirFlowRate: this.result.form.variableAirFlowRate,
        evapAbsoluteFlowDifference:
          this.result.form.mutlakDebi?.evapAbsoluteFlowDifference || 1,
        condAbsoluteFlowDifference:
          this.result.form.mutlakDebi?.condAbsoluteFlowDifference || 1,
        ...cycleItem,
      };
    },
    async CalculateCycle(results, callback, withHavaDebili) {
      console.log(this.result.form);

      if (!this.result.form)
        return this.$emit("get:form", () =>
          this.CalculateCycle(results, callback, withHavaDebili)
        );
      this.result.form.mutlakDebi.evapAbsoluteFlowDifference = 1;
      this.result.form.mutlakDebi.condAbsoluteFlowDifference = 1;
      this.$refs.coolingCapacity.showLoadingModal = true;
      const response = await Requests.Cycle.CalculateMultipleCycle({
        ...this.setForm(),
        multipleCalculateCycleRequest: results,
        withHavaDebili,
      });
      if (response.message === "OK") {
        callback(response.data, "success", withHavaDebili);
      } else {
        callback(response, "error", withHavaDebili);
      }
    },
    async saveCycle(e, loading) {
      console.log(this.seriNo);
      loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("cyclesForm.saving"),
        duration: 250 * 1000,
      });
      const response = await Requests.Cycle.Create(this.setForm());
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("cyclesForm.saveSuccess"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
        this.$emit("show:alertBox", response);
      }
      loading(false);
    },
  },
};
</script>

<style></style>
